export default __webpack_public_path__ + "static/media/cardTechLead.a8d15224.svg";